(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured-video-wrapper').forEach(function(wrapper) {
    var video = wrapper.querySelector('video');
    var overlay = wrapper.querySelector('.video-play-overlay');
    if (!video || !overlay) return;

    var hasControls = video.hasAttribute('controls');
    var wantsMuted = wrapper.getAttribute('data-muted') === 'true';

    if (!hasControls) {
      // Controls off: overlay toggles play/pause
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // Unmute on user interaction if muted setting is off
        if (!wantsMuted && video.muted) {
          video.muted = false;
        }
        if (video.paused) {
          video.play();
          overlay.classList.add('is-playing');
        } else {
          video.pause();
          overlay.classList.remove('is-playing');
        }
      });
    } else {
      // Controls on: overlay starts playback then hides
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!wantsMuted) { video.muted = false; }
        video.play();
        overlay.classList.add('is-hidden');
      });

      // Click video area to toggle play/pause (not all browsers do this natively)
      video.addEventListener('click', function(e) {
        if (e.target === video) {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        }
      });
    }

    // If video is already playing (autoplay succeeded), update overlay state
    video.addEventListener('playing', function() {
      if (hasControls) {
        overlay.classList.add('is-hidden');
      } else {
        overlay.classList.add('is-playing');
      }
    });

    // Handle autoplay failure: if autoplay was expected but video is still paused, show play button
    if (wrapper.getAttribute('data-autoplay') === 'true') {
      video.addEventListener('canplay', function() {
        if (video.paused) {
          overlay.classList.remove('is-playing');
          overlay.classList.remove('is-hidden');
        }
      }, { once: true });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
